import DefaultLayout from './layouts/DefaultLayout.vue';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'Default',
        component: DefaultLayout,
        children: [
            {
                path: '/',
                name: 'GameList',
                component: () => import('@/pages/GameList.vue'),
            },
            {
                path: '/login',
                name: 'LoginPage',
                component: () => import('@/pages/LoginPage.vue'),
            },
            {
                path: '/game/:uuid/player',
                name: 'GameLocalPlayer',
                component: () => import('@/pages/GameLocalPlayer.vue'),
            },
            {
                path: '/game/:gameUuid/controller/:instanceUuid',
                name: 'GamePlayerController',
                component: () => import('@/pages/GamePlayerController.vue'),
            },
            {
                path: '/game/:uuid',
                name: 'GameEditor',
                component: () => import('@/pages/GameEditor.vue'),
            },
        ],
    },
    {
        path: '/play/:instanceUuid',
        name: 'GameRemotePlayer',
        component: () => import('@/pages/GameRemotePlayer.vue'),
    },
    {
        path: '/controller/:instanceUuid',
        name: 'GameController',
        component: () => import('@/pages/GameController.vue'),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
